import { of, Subject } from 'rxjs';
import { OperationService } from '../spec';
export var SetupStatus;
(function (SetupStatus) {
    SetupStatus[SetupStatus["PENDING"] = 0] = "PENDING";
    SetupStatus[SetupStatus["READY"] = 1] = "READY";
    SetupStatus[SetupStatus["REINIT"] = 2] = "REINIT";
    SetupStatus[SetupStatus["FAILED"] = 3] = "FAILED";
})(SetupStatus || (SetupStatus = {}));
const DEFAULT_STATE = {
    status: SetupStatus.PENDING,
};
export class SetupService extends OperationService {
    constructor() {
        super(...arguments);
        this._cleanup = new Subject();
        this.initialState = () => of(DEFAULT_STATE);
        this.cleanup = () => this._cleanup.asObservable();
        this.sideEffect = (s) => console.log(`[${Date.now()}] ${this.identifier}:setup ${s.status}`);
        this.cancel = () => this._cleanup.next(true);
    }
}
//# sourceMappingURL=setup.js.map